var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinersclub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 335,
    viewBox: "0 0 420 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.934 168.947C419.934 69.531 336.954 0.813997 246.038 0.846997H167.797C75.794 0.813997 0.0670166 69.552 0.0670166 168.947C0.0670166 259.878 75.796 334.588 167.797 334.15H246.038C336.951 334.587 419.934 259.857 419.934 168.947Z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.281 14.932C84.212 14.958 16.088 83.24 16.066 167.512C16.087 251.77 84.211 320.044 168.281 320.071C252.369 320.045 320.51 251.77 320.52 167.512C320.508 83.238 252.369 14.958 168.281 14.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.066 167.098C72.146 125.918 97.8131 90.802 134.006 76.848V257.327C97.8131 243.381 72.145 208.283 72.066 167.098ZM203.066 257.373V76.848C239.274 90.769 264.981 125.905 265.047 167.104C264.981 208.316 239.274 243.426 203.066 257.373Z",
    fill: "#0079BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 335,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersclub);
export default __webpack_public_path__ + "static/media/dinersclub.9bb12941e4a630cc5a074b6341fcfa7b.svg";
export { ForwardRef as ReactComponent };